import type { Extension } from '../../../web-client';

export const getExtensionEntryPoint = (extension: Extension, entryPoint?: string): string => {
	const defaultEntryPoint = extension.properties.resource;
	const alternativeEntryPoint = entryPoint && extension.properties[entryPoint]?.resource;

	return alternativeEntryPoint || defaultEntryPoint;
};
